import axios from "axios";
import { IsAuthorized } from "src/authentication/IsAuthorized";
import { getJWT } from "src/helper/localStore/getJWT";

class BusinessUnitPerProductServices {
    async getByBusinessUnit(business_unit_id:number): Promise<any[]> {
        try {
        const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-business-unit/business_unit_id/${business_unit_id}`, {
            headers: { 'authentication-token': getJWT()! }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async getProductsByBusinessUnit(business_unit_id:number): Promise<any[]> {
        try {
        const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/business-unit/products/${business_unit_id}`, {
            headers: { 'authentication-token': getJWT()! },
            params:{
                filter_by_is_offline:false
            }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async editProductsByBusinessUnit(id:number, body:any): Promise<any[]> {
        try {
        const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-business-unit/`,
            body, 
            {
            headers: { 'authentication-token': getJWT()! },
            params:{
                ent_id:id
            }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async createProductsByBusinessUnit(body:any): Promise<any[]> {
        try {
        const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-business-unit/`,
            body, 
            {
            headers: { 'authentication-token': getJWT()! },
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }

    async deleteProductsByBusinessUnit(id:number): Promise<any[]> {
        try {
        const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/product-payment-by-business-unit/`,
            {
            headers: { 'authentication-token': getJWT()! },
            params:{
                ent_id:id
            }
        })
        return res.data
        } catch (error) {
        IsAuthorized(error)
        throw error;
        }
    }
}

export const businessUnitPerProductServices = new BusinessUnitPerProductServices()